export default __webpack_public_path__ + "static/banner-media-release-latitudepay-moshtix-18b1b098bc7ac70c278927b06f537efd.jpg";